// extracted by mini-css-extract-plugin
export var unselectedPin = "parking-pin-module--unselectedPin--3GpUp";
export var selectedPin = "parking-pin-module--selectedPin--2NM2H";
export var currentFee = "parking-pin-module--currentFee--Ortoh";
export var invalidStatusItem = "parking-pin-module--invalidStatusItem--13wpU";
export var statusItemText = "parking-pin-module--statusItemText--1ZgMF";
export var emptyStatusItem = "parking-pin-module--emptyStatusItem--3G9pf";
export var crowdedStatusItem = "parking-pin-module--crowdedStatusItem--2Myja";
export var fullStatusItem = "parking-pin-module--fullStatusItem--3UdHm";